export default __webpack_public_path__ + "static/media/3-3-4.3977e8c5.jpg";